import type { SVGProps } from 'react';
const SvgNorthWest = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#north_west_svg__a)">
      <path
        fill="currentColor"
        d="M5 15h2V8.41L18.59 20 20 18.59 8.41 7H15V5H5v10Z"
      />
    </g>
    <defs>
      <clipPath id="north_west_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgNorthWest;
